module.exports = __webpack_public_path__ + "static/media/COLOR_TAB.1c3db4ce.png";